import React from 'react'
import PropTypes from 'prop-types'
const OzoneSwimLogo = ({ size, primary, secondary, ...otherProps }) => (
	<svg
		id="ozone-swim-logo"
		aria-hidden="true"
		focusable="false"
		role="img"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="Ozone Swim Logo"
		width={size ? size : ''}
		viewBox="0 0 715.61 125.76"
		{...otherProps}
	>
		<title>Ozone Swim Logo</title>
		<g id="Layer_2" data-name="Layer 2">
			<g id="OzoneSwim_Page" data-name="OzoneSwim Page">
				<g id="OzoneswimLogo">
					<path
						className="cls-1"
						fill={'#58c8df'}
						d="M400.63,125.65a23.86,23.86,0,0,0,5.49-7.23c3.84-7.78,4.49-16.2,1.54-25.23a52.93,52.93,0,0,0-6.11-12.11c-2.79-4.33-5.78-8.44-8.65-12.67a128.65,128.65,0,0,1-9.31-15.47c-4.19-8.54-4.79-17-1.12-25.37a31.31,31.31,0,0,1,6.07-9c.09-.1.17-.25.41-.15-.82,1.37-1.63,2.73-2.32,4.18a24.44,24.44,0,0,0-1.37,17.93,40.92,40.92,0,0,0,4.82,10.21,79.62,79.62,0,0,0,5.59,7.72c3.91,4.88,8.11,9.38,12.22,14a135.59,135.59,0,0,1,9.26,11.24,47.61,47.61,0,0,1,6.18,11,22.09,22.09,0,0,1,.23,16.11c-2.58,6.77-6.86,11.08-12.63,13.33a24.46,24.46,0,0,1-9.76,1.62,4.49,4.49,0,0,1-.54-.09"
					/>
					<path
						className="cls-1"
						fill={'#58c8df'}
						d="M37.08,117.62c21.23,0,29.44-7.78,29.44-31.84S58.31,54.22,37.08,54.22,7.64,61.72,7.64,85.78s8.21,31.84,29.44,31.84M74.16,85.78c0,26.89-10.19,38.5-37.08,38.5S0,112.67,0,85.78,10.19,47.57,37.08,47.57,74.16,58.89,74.16,85.78"
					/>
					<path
						className="cls-1"
						fill={'#58c8df'}
						d="M81.81,117.06c0-3.26,2.12-6.09,3.68-7.79L128.8,58.32a3.46,3.46,0,0,0,1.13-2.12c0-1.13-1-1.13-1.42-1.13H83.93V48.42h48a6.13,6.13,0,0,1,6.51,6.08A10.48,10.48,0,0,1,136,60.59L90.87,113.94c-.43.57-1.14,1-1.14,2,0,.43.15.71.43.71l.85.14h47.55v6.66H91c-3.4,0-9.2-.71-9.2-6.37"
					/>
					<path
						className="cls-1"
						fill={'#58c8df'}
						d="M183.29,117.62c21.23,0,29.43-7.78,29.43-31.84s-8.2-31.56-29.43-31.56-29.44,7.5-29.44,31.56,8.21,31.84,29.44,31.84m37.08-31.84c0,26.89-10.19,38.5-37.08,38.5s-37.08-11.61-37.08-38.5,10.19-38.21,37.08-38.21,37.08,11.32,37.08,38.21"
					/>
					<path
						className="cls-1"
						fill={'#58c8df'}
						d="M232.83,60.31c0-7.22,2.26-11.89,10.19-11.89h27.6c15.56,0,21.65,8.35,21.65,23.06v52h-7.36V71.48c0-9.05-3-16.41-14.29-16.41h-25.9c-2.83,0-4.53.56-4.53,5.38v63h-7.36Z"
					/>
					<path
						className="cls-1"
						fill={'#58c8df'}
						d="M358.37,81.82c2.41,0,3.11-2,3.11-3.4v-1c0-18.4-9.05-23.21-24.48-23.21-16.7,0-24.63,6.09-24.63,27.6Zm-27.74,41.61c-20.66,0-25.9-15.57-25.9-36.94,0-25.34,6.79-38.92,32.13-38.92,18.54,0,32.27,7.36,32.27,28.59,0,8.63-2.27,12.31-10.76,12.31h-46c0,13.16,2.27,28.3,18.26,28.3h36.8v6.66Z"
					/>
					<path
						fill="#588095"
						className="cls-2"
						d="M477.5,114.32c.19.47.4,1,.64,1.49s.54.78.92.78.81-.31,1-.93a8.93,8.93,0,0,1,.43-1.2L496.24,53.7q1.13-4,3.26-5a7.41,7.41,0,0,1,7.67,0q2.13,1.06,3.26,5l15.76,60.76a8.93,8.93,0,0,1,.43,1.2q.28.93,1,.93t.93-.78c.23-.52.44-1,.63-1.49l16.9-65.88h7.38L535,118.29a12.76,12.76,0,0,1-2.2,4.33q-1.49,1.92-5,1.92a7.55,7.55,0,0,1-3.4-.71,7,7,0,0,1-2.27-1.71,8.64,8.64,0,0,1-1.35-2.05,7.56,7.56,0,0,1-.64-1.92L504.76,59.38a18.12,18.12,0,0,0-.64-1.85c-.24-.57-.5-.85-.78-.85s-.55.28-.78.85a16,16,0,0,0-.64,1.85l-15.34,58.77c-.19.57-.42,1.2-.71,1.92a7.23,7.23,0,0,1-1.27,2.05,7.4,7.4,0,0,1-2.2,1.71,7.5,7.5,0,0,1-3.48.71q-3.56,0-5-1.92a12.76,12.76,0,0,1-2.2-4.33L453.22,48.44h7.38Z"
					/>
					<path
						fill="#588095"
						className="cls-2"
						d="M561.4,48.44h7.39v75.25H561.4Zm-.28-23h8V36.48h-8Z"
					/>
					<path
						fill="#588095"
						className="cls-2"
						d="M584.4,60.37a15.66,15.66,0,0,1,2.13-8.66c1.42-2.18,4.11-3.27,8.09-3.27h69.7q11.79,0,16.76,6t5,17.1v52.11h-7.38v-52a30,30,0,0,0-.64-6.37,13.7,13.7,0,0,0-2.27-5.24,10.91,10.91,0,0,0-4.4-3.54,16.7,16.7,0,0,0-7-1.28H638.91v68.43h-7.38V55.26H596.32a5.71,5.71,0,0,0-3.34.85c-.8.56-1.2,2.08-1.2,4.53v63.05H584.4Z"
					/>
					<path
						fill="#588095"
						className="cls-2"
						d="M421.81,0c-.91,1-1.78,1.78-2.53,2.74-4.71,6-6.82,13.35-6.12,22.08a36.53,36.53,0,0,0,4.53,14.23,128.68,128.68,0,0,0,8.89,13.85,160.28,160.28,0,0,1,12.14,19.49,31.25,31.25,0,0,1,3.67,16.11,27.87,27.87,0,0,1-4.23,13.13,28.79,28.79,0,0,1-4.34,5.54c-.16-.42.08-.54.19-.71a26.14,26.14,0,0,0,4.31-14.66A27.26,27.26,0,0,0,436,81.75a56.85,56.85,0,0,0-8.07-13.14c-4.25-5.45-8.88-10.41-13.42-15.49A122.82,122.82,0,0,1,403.92,40a41.21,41.21,0,0,1-5.22-10.22,21.92,21.92,0,0,1,.48-15.51c2.72-6.65,7.14-10.71,12.87-12.87A25.27,25.27,0,0,1,421.3,0l.51,0"
					/>
					<path
						fill="#588095"
						className="cls-2"
						d="M702.94,61.66v-8.3c0-.71.16-1.35,1.71-1.35h3.93c2,0,2.78.88,2.78,3.1,0,2.7-1.35,2.9-2.11,2.9h-1l3.62,3.65h-2.15l-3.21-3.25a1.11,1.11,0,0,1-.48-1c0-.71.52-.71.83-.71h1.39c.56,0,1.43,0,1.43-.79v-1.4a1.13,1.13,0,0,0-1.27-1.1h-3.21c-.48,0-.68.07-.68.71v7.54ZM714,57.1c0-5-1.39-7.31-6.63-7.31-4.76,0-7.11,1.31-7.11,7,0,4.92,1.27,7.38,6.43,7.38S714,62.85,714,57.1m-15.32-.2c0-6.07,2.26-8.45,8.53-8.45,5.87,0,8.38,1.86,8.38,8.45,0,6.35-2.43,8.65-8.86,8.65-5.55,0-8-2.38-8-8.65"
					/>
				</g>
			</g>
		</g>
	</svg>
)
OzoneSwimLogo.propTypes = {
	size: PropTypes.string,
	primary: PropTypes.string,
	secondary: PropTypes.string,
}
OzoneSwimLogo.defaultProps = {
	size: '',
	primary: '#57c8de',
	secondary: '#598aa9',
}
export default OzoneSwimLogo
